import { ColDef, ICellRendererParams } from "ag-grid-community";
import { Stack, Tooltip, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import {
  dateFromUtcByTimeZone,
  formatDate,
} from "@/utils/helpers/date-time/datetime-format";
import { UpcomingAction } from "@/services/cloudchipr.api";

export const automationsFoundResourcesGridUpcomingActionsColumDef: ColDef = {
  field: "resource.upcoming_actions",
  pinned: "right",
  cellStyle: { padding: 0 },
  headerName: "Action Date",
  suppressHeaderMenuButton: true,
  suppressHeaderContextMenu: true,
  cellRenderer: ({ data }: ICellRendererParams) => {
    const resource = data.resource;
    const isProtected = resource?.is_protected;

    const upcomingActions = resource.upcoming_actions as UpcomingAction[];
    const upcomingActionDate = upcomingActions?.at(0)?.action_date;

    const date =
      upcomingActionDate && !isProtected
        ? formatDate(dateFromUtcByTimeZone(upcomingActionDate) ?? "", {
            type: "dateTime",
          })
        : "";

    const utcDate = formatDate(upcomingActionDate ?? "", {
      type: "dateTime",
    });

    return (
      <Tooltip
        title={
          date
            ? `Users got notified about this resource. Cloudchipr will take action on this resource on ${utcDate} in UTC time.`
            : ""
        }
      >
        <Typography variant="body2" sx={{ px: 2 }}>
          {date || "-"}

          {upcomingActionDate && !isProtected && (
            <Stack
              direction="row"
              p={0.5}
              width="fit-content"
              borderRadius={1}
              bgcolor={green[50]}
              alignItems="center"
              mb={0.5}
            >
              <NotificationsActiveOutlinedIcon
                sx={{ color: "success.light" }}
                fontSize="small"
              />
              <Typography
                color="success.light"
                fontWeight="bold"
                ml={0.5}
                fontSize="small"
              >
                Notified
              </Typography>
            </Stack>
          )}
        </Typography>
      </Tooltip>
    );
  },
};
